import React, {useEffect, useState} from 'react';
import "../assets/css/componentStyles/CourseDetailComponent.css"
import {Button, Rating, Spinner} from "flowbite-react";
import Modal from "react-modal";
import {Link, useNavigate, useParams} from 'react-router-dom';
import {getCourseDetails, getBookedCourse} from "../services/courseService";
import {CourseType} from "../model/course/courseInterface";
import CardDetailSkeleton from "../CardDetailSkeleton";
import {isAuthenticated} from "../services/authService";
import {toast} from "react-toastify";
import {handleBookCourse} from "../services/courseService";
import {getUser} from "../services/userService";
import {UserType} from "../model/user/userInterface";
import Star from "./shared/Star";
import ContactUsForm from "./ContactUsForm";
import {Contact} from "../routes/constants";

const CourseDetailComponent = ({course}: CourseType | any) => {
    const navigate = useNavigate();
    const popupStyle = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    const contactModal = {
        content: {
            width: "30%",
            padding: "0px",
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    const { id } = useParams();

    const [courseDetail, setCourseDetail] = useState<CourseType>(course);
    const [popUpIsOpen, setPopupIsOpen] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);
    const [bookCourseDetail, setBookCourseDetail] = useState({});
    const [contactModalIsOpen, setContactModalIsOpen] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);
    const [bookedCourseList, setBookedCourseList] = useState([]);

    const handleBookButton = (name:string, id:any) => {
        if (!isAuthenticated()) {
            toast("Please login to book this course!")
        } else {
            openPopUp();
            setBookCourseDetail({course_name: name, course_id: id})
        }
    }


    const handleBookThisCourse = async () => {
        setLoader(true)
        const user:UserType = await getUser();
        const course = {...bookCourseDetail, User_UID: user.id}
        try {
            setLoader(true);
            const res = await handleBookCourse(course);
            if (res?.status === 200) {
                setLoader(false)
                toast.success("Course successfully booked!")
                closePopup();
                await handleBookedCourseList();
            }
        } catch (error:any) {
            toast.warn(error.message)
            closePopup()
        }
    }

    const openPopUp = () => {
        setPopupIsOpen(!popUpIsOpen)
    }

    const closePopup = () => {
        setPopupIsOpen(false)
    }

    const handleGetCourseDetails = async () => {
        try {
            setLoading(true)
            const course: any = await getCourseDetails(id);
            setCourseDetail(course);
            setLoading(false)
        } catch (e: any) {
            console.log(e.message)
        }
    }

    const closeContactModal = () => {
        setContactModalIsOpen(false)
    }

    const openContactModal = () => {
        if (window.innerWidth < 768) {
            navigate(Contact)
        } else {
            setContactModalIsOpen(!contactModalIsOpen)
        }
    }

    useEffect(() => {
        if (id)
            handleGetCourseDetails();
    }, [id])

    const handleBookedCourseList = async () => {
        const user:UserType = await getUser();
        if (user) {
            const bookedData:any = await getBookedCourse(user?.id);
            if (bookedData) {
                setBookedCourseList(bookedData);
            }
        }

    }
    useEffect(() => {
        handleBookedCourseList();
    }, []);

    const checkIsBooked = (id: string) => {
        let isBooked = false;
        if (bookedCourseList) {
            bookedCourseList.forEach((list: any) => {
                if (list?.course_id === id) {
                    isBooked = true;
                }
            })
        }
        console.log('booked ', isBooked, id, bookedCourseList)
        return isBooked;
    }
    return (
        <div className="h-[75vh]">
            {
                loading && <CardDetailSkeleton/>
            }
            {
                !loading &&
                <div className="container mx-auto md:p-0 p-4">
                    <div className="block">
                        <div className="flex sm:flex-row flex-col md:items-center">
                            <div className="block mb-4 sm:mb-0">
                                <img src={courseDetail?.image || "https://img-b.udemycdn.com/course/240x135/394676_ce3d_5.jpg"} alt="courses-banner" className="min-w-[270px] h-[176px] sm:w-auto w-full" />
                            </div>
                            <div className="justify-between w-full sm:ml-4">
                                <div className="">
                                    <div className="flex justify-between">
                                        <div className="flex flex-col md:w-[63%] w-[72%]">
                                            <h3 className="sm:mb-1 mb-0 text-lg sm:text-xl tracking-tight text-primary dark:text-white leading-tight font-extrabold">{courseDetail?.name}</h3>
                                            <p className="lg:block hidden lg:max-w-[32rem] md:max-w-[400px] max-w-[250px] mb-1 sm:text-base text-sm text-primary !leading-tight dark:text-gray-400 font-normal">{courseDetail?.description_small}</p>
                                            <p className="text-base font-medium sm:mb-1 mb-0">{courseDetail?.type}</p>
                                            <Rating className="sm:mb-1 md:mb-1 mb-1">
                                                <Star reviews={courseDetail?.review_score?.toString().replace(',', '.')}/>
                                                <p className="ml-2 tracking-tight text-sm font-bold text-[#1c1d1f]">
                                                    {courseDetail?.review_score ? Math.round(parseFloat(courseDetail?.review_score)) : ""}
                                                </p>
                                                <Link
                                                    to="#"
                                                    className="text-sm ml-2 font-normal underline underline-offset-2 hover:no-underline dark:text-white"
                                                >
                                                    {courseDetail?.number_of_reviews} {courseDetail?.number_of_reviews && "reviews"}
                                                </Link>
                                            </Rating>
                                            <div className="flex flex-col">
                                                <div className="">
                                                    <p className="text-sm mb-1">{courseDetail?.educational_institution}</p>
                                                </div>
                                                <div className="block md:hidden">
                                                    <p className="font-semibold text-medium text-gray-500 mb-1">€{courseDetail?.price}</p>
                                                </div>
                                                {
                                                    (courseDetail?.location?.length === 1 && courseDetail?.location[0] === "Online") ?
                                                        courseDetail?.location[0] :
                                                        (!courseDetail?.location) ? "" :
                                                            <select
                                                                name="locations"
                                                                id="locations-select"
                                                                onChange={(e) => e.target.value}
                                                                className="w-1/2 min-w-[13.4rem] border-gray-400"
                                                            >
                                                                {
                                                                    courseDetail?.location && (
                                                                        courseDetail?.location.map((loc:string, idx:number) => {
                                                                            return (
                                                                                <option
                                                                                    value=""
                                                                                    key={idx}
                                                                                >
                                                                                    { loc }
                                                                                </option>
                                                                            )
                                                                        })
                                                                    )
                                                                }
                                                            </select>
                                                }
                                            </div>
                                            <div className="block md:hidden my-[10px]">
                                                <button className="px-12 py-3 text-center text-white cursor-pointer bg-[#548235] hover:bg-[#5a8600] max-w-fit" onClick={()=> handleBookButton(courseDetail?.name, courseDetail?.id)}>Book this course</button>
                                            </div>
                                        </div>
                                        <div className=" text-right md:block hidden">
                                            <p className="font-bold text-xl text-gray-500 ">€{courseDetail?.price}</p>
                                            {
                                                checkIsBooked(courseDetail?.id) ?
                                                    <button className="px-6 py-3 text-black border border-black mt-3"
                                                    >
                                                        Booked
                                                    </button>
                                                    :
                                                    <button className="px-6 py-3 text-white mt-3 cursor-pointer bg-[#548235] hover:bg-[#5a8600]"
                                                            onClick={()=> handleBookButton(courseDetail?.name, courseDetail?.id)}
                                                    >
                                                        Book this course
                                                    </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*Book course PopUp*/}
                        <div className="flex items-center justify-center my-8">
                            <Modal
                                isOpen={popUpIsOpen}
                                style={popupStyle}
                                onRequestClose={closePopup}
                                ariaHideApp={false}
                            >
                                <div className="text-center">
                                    <div className="flex flex-col gap-8">
                                        <div>
                                            <button
                                                onClick={handleBookThisCourse}
                                                className="bg-[#548235] hover:bg-[#5a8600] px-12 py-4 text-white font-semibold min-w-[17rem]"
                                            >
                                                {
                                                    loader ? <Spinner aria-label="Default status example" /> : "Confirm your booking!"
                                                }
                                            </button>
                                        </div>
                                        <div>
                                            <p className="text-base">
                                                Our learning specialist will contact you within 2 office days <br/> with the learning plan and set a date and location
                                            </p>
                                        </div>
                                        <div>
                                            <p className="underline underline-offset-2 cursor-pointer hover:text-blue-600"
                                               onClick={openContactModal}>
                                                Question? Contact us
                                            </p>
                                            <Modal
                                                isOpen={contactModalIsOpen}
                                                style={contactModal}
                                                onRequestClose={closeContactModal}
                                                ariaHideApp={false}
                                            >
                                                <ContactUsForm closeContactModal={closeContactModal}/>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        {/*Description*/}
                        <div className="description pb-6">
                            <div className="description" dangerouslySetInnerHTML={{ __html: courseDetail?.description_full }} />
                        </div>
                    </div>
                </div>
            }
        </div>

    );
};

export default React.memo(CourseDetailComponent);
